import type { ReactNode, RefObject } from 'react';
import { Menu } from '@terra/ui-design-system';
import { MenuPanel } from './MenuPanel';
import {
  getSubmenuAnchorRect,
  SUBMENU_POSITIONING_BASE,
} from './target-selector/submenuPositioning';

type SidebarSubmenuProps = {
  triggerRef: RefObject<HTMLDivElement | null>;
  trigger: ReactNode;
  children: ReactNode;
  minW?: string;
  maxW?: string;
};

export function SidebarSubmenu({
  triggerRef,
  trigger,
  children,
  minW,
  maxW,
}: SidebarSubmenuProps) {
  return (
    <Menu.Root
      positioning={{
        ...SUBMENU_POSITIONING_BASE,
        getAnchorRect: () => getSubmenuAnchorRect(triggerRef),
      }}
    >
      {trigger}
      <MenuPanel minW={minW} maxW={maxW}>
        {children}
      </MenuPanel>
    </Menu.Root>
  );
}
